import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContactDetails from "../../components/contacts/ContactDetails";
import { ContactMergeHistory } from "../../components/contacts/ContactMergeHistory";
import { ContactMergeModal } from "../../components/contacts/ContactMergeModal";
import SharedContactLeadsTable from "../../components/contacts/SharedContactLeadsTable";

import Card from "../../components/shared/Card/Card";
import { ButtonInput } from "../../components/shared/Inputs/ButtonInput";
import LoadingWheel from "../../components/shared/LoadingWheel";

import { useAuth } from "../../contexts/AuthContext";
import { usePageNameContext } from "../../contexts/PageTitleContext";

import useContactLeads from "../../data/useContactLeads";
import useContactSingle from "../../data/useContactsSingle";

export default function Contact() {
  const { t } = useTranslation("accounts");
  const { contactId } = useParams();
  const { contact } = useContactSingle(contactId == null ? "" : contactId);
  const { contactLeads } = useContactLeads(contactId, "Contact");
  const { claims } = useAuth();
  const { setInfo } = usePageNameContext();
  const [mergeOpen, setMergeOpen] = useState(false);

  useEffect(() => {
    if (!contact.isLoading) {
      setInfo({
        name: `${contact.data?.data.fullname!}`,
        desc: "View and manage the contact record here",
      });
    }
  }, [setInfo, contact.isLoading, contact.data]);

  if (contact.isLoading || contact.data == null) {
    return (
      <div className="min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
        <LoadingWheel />
      </div>
    );
  } else {
    const leads = contactLeads.data?.data ?? [];

    return (
      <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="space-y-4 lg:col-span-2">
          <ContactDetails contact={contact.data.data} />

          <Card
            title={t("Leads ({{count}})", { count: leads.length })}
            subtitle={t("Every lead on this contact. Leads brought here by a merge say where they came from.")}
            bodyClassName="p-4"
            headerRight={
              claims?.isAdmin && (
                <ButtonInput label={t("Merge")} isSubmit={false} onClick={() => setMergeOpen(true)} classes="" />
              )
            }
          >
            {contactLeads.isLoading ? (
              <LoadingWheel />
            ) : leads.length > 0 ? (
              <SharedContactLeadsTable leads={leads} variant="table" />
            ) : (
              <p className="text-sm text-gray-500">{t("No leads")}</p>
            )}
          </Card>
        </div>

        {claims?.isAdmin && (
          <div>
            <ContactMergeHistory contactId={contact.data.data.id} />
          </div>
        )}

        {claims?.isAdmin && <ContactMergeModal contact={contact.data.data} open={mergeOpen} setOpen={setMergeOpen} />}
      </div>
    );
  }
}
